export default __webpack_public_path__ + "img/be647f117fb1eb8f67e67757441a6b34.jpg";